const ICantMakeYouLoveMe = [
	'[Verse 1]',
	'Turn down the lights,',
	'turn down the bed',
	'Turn down these voices inside my head',
	'Lay down with me, tell me no lies',
	"Just hold me close, don't patronize",
	"Don't patronize me",
	'',
	'[Chorus]',
	"Cause I can't make you love me if you don't",
	"You can't make your heart feel something it won't",
	'Here in the dark, in these final hours',
	"I will lay down my heart and I'll feel the power",
	"But you won't, no, you won't",
	"Cause I can't make you love me if you don't",
	'',
	'[Verse 2]',
	"I'll close my eyes, then I won't see",
	"The love you don't feel when you're holding me",
	"Morning will come and I'll do what's right",
	'Just give me till then to give up this fight',
	'And I will give up this fight',
	'',
	'[Chorus]',
	"Cause I can't make you love me if you don't",
	"You can't make your heart feel something it won't",
	'Here in the dark, in these final hours',
	"I will lay down my heart and I'll feel the power",
	"But you won't, no, you won't",
	"Cause I can't make you love me if you don't",
];

export default ICantMakeYouLoveMe;
